import {
    sorterByStringDate, sorterNumber, sorterString,
} from 'utils/sorting';

export const casesInProgressColumns = ({
    t,
}) => [
    {
        key: 'case_id',
        title: t('CreateCase.CasesInProgress.Table.CaseId'),
    },
    {
        key: 'date',
        title: t('CreateCase.CasesInProgress.Table.Date'),
        sortable: true,
        sorter: sorterByStringDate('date'),
    },
    {
        key: 'advisor',
        title: t('CreateCase.CasesInProgress.Table.Advisor'),
    },
    {
        key: 'type',
        title: t('CreateCase.CasesInProgress.Table.Type'),
        sortable: true,
        sorter: sorterString('type'),
    },
    {
        key: 'status',
        title: t('portfolios.columns.status'),
        sortable: true,
        sorter: sorterString('status'),
    },
    {
        key: 'caseDetails',
        title: '',
    },
];

export const casesSubmittedColumns = ({
    t,
}) => [
    {
        key: 'case_id',
        title: `${t('CreateCase.CasesInProgress.Table.LPZCaseId')}`,
        sortable: true,
        sorter: sorterNumber('case_id'),
    },
    {
        key: 'date',
        title: t('CreateCase.CasesInProgress.Table.LastModified'),
        sortable: true,
        sorter: sorterByStringDate('date'),
    },
    {
        key: 'advisor',
        title: t('ApplicationDetails.AdvisorySection.ProductApplications.SubmittedBy'),
    },
    {
        key: 'type',
        title: t('CreateCase.CasesInProgress.Table.Type'),
        sortable: true,
        sorter: sorterString('type'),

    },
    {
        key: 'status',
        title: t('portfolios.columns.status'),
        sortable: true,
        sorter: sorterString('status'),
    },
    {
        key: 'caseDetails',
        title: '',
    },
];
